import invariant from 'fbjs/lib/invariant.js';

export
/**
 * Apply some patches to schema **before** it is used in the fetching extras.
 * @todo: Review and re-arrange patching logic to avoid this function.
 * @todo: Alt: move here some logic from schema re-ware.
 * @param schema
 * @return {*}
 */
function patchSchema(schema) {
  /* Patch text widget, due to replacing absolute px in text,
   we did not need own content declaration for each S/A TV sizes.
   Related to: https://jira.x2sy.com/browse/RMI-2547
   */
  for (const widgetKey in schema.i18nEntities.widgets) {
    const widget = schema.i18nEntities.widgets[widgetKey];
    if (/*schema.data.platform !== 'tv' || */widget.type !== 'text') {
      continue;
    }
    if (typeof widget.content === 'string') {
      continue;
    }
    invariant('720' in widget.content, `Widget ${widgetKey} should have content for 720p`);
    widget.content = widget.content['720'];
  }
  return schema;
}
